export default __webpack_public_path__ + "static/media/PC-UIPLATE.4e0225de.png";